export enum RequestRespondentTypeCode {
	Individual = "INDIVIDUAL",
	Establishment = "ESTABLISHMENT",
}
